const SET_SNACKBAR = "SET_SNACKBAR";
const RESET_STATE = "RESET_STATE";

const getDefaultState = () => {
  return {
    color: "",
    bottom: false,
    top: false,
    left: false,
    right: false,
    timeout: 5000,
    message: "",
    button: "",
    buttonColor: "",
    icon: null,
    iconColor: "white"
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    setSnackbar({ commit }, payload) {
      payload ? commit("SET_SNACKBAR", payload) : commit("RESET_STATE");
    },

    snackbarSuccess({ commit }, message) {
      commit("SET_SNACKBAR", {
        color: "success",
        button: "OK",
        icon: "check_circle",
        message
      });
    },

    snackbarError({ commit }, message) {
      commit("SET_SNACKBAR", {
        color: "error",
        button: "OK",
        icon: "error",
        message
      });
    }
  },

  mutations: {
    [SET_SNACKBAR](state, payload) {
      Object.assign(state, payload);
    },
    [RESET_STATE](state) {
      Object.assign(state, getDefaultState());
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/snackbar.js